import React from "react";
import { Route } from "react-router-dom";
import ShopPage from "../pages/shop/ShopPage";
import ProductListPage from "../pages/shop/ProductListPage";
import PDP from "../pages/shop/PDP";
import ShopLayout from "../layouts/ShopLayout";
import CheckoutLayout from "../layouts/CheckoutLayout";
import { ShopFilterProvider } from "../context/ShopFilterContext";
import HomePage from "../pages/HomePage";
import CartPage from "../pages/shop/CartPage";
import CheckoutPage from "../pages/shop/CheckoutPage"
import CheckoutReviewPage from "../pages/shop/CheckoutReviewPage"
import MockGatewayPage from "../pages/shop/MockGatewayPage"
import PaymentResultPage from "../pages/shop/PaymentResultPage"
import AboutPage from "../pages/shop/AboutPage";
import ContactPage from "../pages/shop/ContactPage";
import FAQPage from "../pages/shop/FAQPage";
import RootCategoryListPage from "../pages/shop/RootCategoryListPage";


export default function ShopRoutes() {

  return (
      <>
          <Route
          path=""
          element={
            <ShopFilterProvider>
              <ShopLayout />
            </ShopFilterProvider>
          }
          >
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shopping/product-list/" element={<ProductListPage />} />
            <Route path="/shopping/product-detail/:slug/" element={<PDP />} />
            <Route path="/cart/" element={<CartPage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/root-category-list" element={<RootCategoryListPage />} />
            <Route path="/faq" element={<FAQPage />} />
          </Route>
        <Route element={<CheckoutLayout/>}>
          <Route path="/checkout/checkout/" element={<CheckoutPage />} />
          <Route path="/checkout/review/" element={<CheckoutReviewPage />} />
          <Route path="/mock-gateway/zarinpal/pay/:authority/" element={<MockGatewayPage />} />
          <Route path="/payment-result" element={<PaymentResultPage />} />
        </Route>
      </>
    );
}